import { transform } from 'lodash-es'

const mergeReducers = (...reducers) => {
  // will call each reducer with no action and no state to get it initial state
  // and push the keys to the list
  const reducerPropsLists = reducers.map((reducer) =>
    Object.keys(reducer(undefined, { type: '' }))
  )

  return (state, action) => {
    return transform(
      reducerPropsLists,
      (acc, reducerPropsList, index) => {
        const newState = reducers[index](state, action)

        reducerPropsList.forEach((reducerProp) => {
          acc[reducerProp] = newState[reducerProp]
        })
      },
      {}
    )
  }
}

export default mergeReducers
